import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';
import homeScreenService from '../../service/homeScreen.service';

const HomeScreenReports = ({ refetch, selection, viewField }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { selectedValues, setSelectedValues } = selection;
  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  useEffect(() => {
    if (!selectedValues?.id) setRowSelectionModel([]);
  }, [selectedValues]);

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: { sortModel: [{ field: 'name', sort: 'asc' }] },
    pagination: { paginationModel: { page: 0, pageSize: 25 } },
    density: 'compact',
  };

  const getList = (gridState) => {
    homeScreenService.getList(gridState).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  };

  const columns = dataGridPremiumColumns([
    { field: 'name', headerName: 'Név', type: 'string', minWidth: 180, flex: 1 },
    { field: 'description', headerName: 'Leírás', type: 'string', minWidth: 220, flex: 1 },
    { field: 'active', headerName: 'Aktív', type: 'boolean', width: 90 },
    { field: 'isUserSelectable', headerName: 'User által választható', type: 'boolean', width: 170 },
  ]);

  return (
    <Box sx={{ m: 2 }}>
      <DatagridPremiumUi
        datagridIdentifier={DataGridIdentifiers.homeScreenReports}
        datagridInitialState={initialState}
        dataLoader={getList}
        rows={reports.rows}
        rowCount={reports.rowCount}
        columns={columns}
        refetch={{ refetchTable, setRefetchTable }}
        paginationAndfilterMode="server"
        onRowClick={(rowData) => {
          if (viewField) setSelectedValues(rowData.row);
        }}
        onRowSelectionModelChange={setRowSelectionModel}
        rowSelectionModel={rowSelectionModel}
        disableRowSelectionOnClick={!viewField}
        height={750}
      />
    </Box>
  );
};

export default HomeScreenReports;
